var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.decisionMade)?_c('span'):_c('TestA')
}
var staticRenderFns = []

export { render, staticRenderFns }